import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCreateGeneralEvent = loadable(() => import(/* webpackChunkName: "content/creategeneralevent" */ './CreateGeneralEvent'), 'CreateGeneralEvent');
